import { Dialog, DialogButtons, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import { useTranslation } from 'react-i18next';
import { DobButton } from '@dedalusdiit/dob-components';

export interface DeleteWorklistDialogProps {
    isOpen: boolean;
    onOk: () => void;
    onCancel: () => void;
    worklistTitle: string | undefined;
}

export function DeleteWorklistDialog(props: Readonly<DeleteWorklistDialogProps>): React.ReactElement {
    const { t } = useTranslation();
    const {
        isOpen,
        onOk,
        onCancel,
        worklistTitle,
    } = props;

    return (
        <Dialog open={isOpen}>
            <DialogTitle>
                <span>
                    {t('Delete')} {t('Worklist')} - {worklistTitle}
                </span>
            </DialogTitle>
            <DialogContent center>
                <span>{t('Are you sure')}?</span>
            </DialogContent>
            <DialogButtons>
                <DobButton color="danger" onClick={onOk}>
                    {t('Delete')}
                </DobButton>
                <DobButton color="silent" onClick={onCancel}>
                    {t('Cancel')}
                </DobButton>
            </DialogButtons>
        </Dialog>
    );
}
